<template>
    <paper id="threeplBillingOrder">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :optionNum="''"
            :loading="loading"
            :currentPage="searchParams.pageNo"
            :searchTotalTitle="searchTotalTitle"
            @saveData="saveData"
            @row-db-click="rowDBclick"
            @getTableConfigList="getTableConfigList"
            @check-btn="checkBtn"
            @edit-btn="editBtn"
            @btnClick="btnClick"
            @switch-change="switchChange"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @search-list-change="searchListChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            searchId="test"
            pageID="test"
        >
            <div slot="table-module-btn">
                <reportExport v-if="false" #default="{ submit }" reportCode="REPORT_OTP_STATISTISTICS_BILLING">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="''" class="mgl-10">
                        <el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <lots-button v-has="'02100002'" type="primary" @click="verify()">审 核</lots-button>
                <lots-button v-has="'02100003'" type="primary" @click="verify(1)">取消审核</lots-button>
                <lots-button v-has="'02100004'" type="primary" @click="pushOrder()">推送计费</lots-button>
                <!-- <lots-button v-has="'02100005'" type="primary" @click="pushOrder(1)">取消计费</lots-button> -->
            </div>
        </m-pane>
        <Import
            v-if="false"
            ref="Import"
            :ImportConfig="config.ImportConfig"
            :ImportContent="config.ImportContent"
            @getUploadResult="getUploadResult"
        ></Import>
        <EditDialog
            ref="editDialog"
            @success="toFirstPage"
        ></EditDialog>
        <Log
            :title="logTitle"
            :visible.sync="logVisible"
            :tableData="logTableData"
            :items="config.logColumns"
            :logOrderNo="logOrderNo"
            :logJumpParams="logJumpParams"
            :currentData="{...customerOrderInfo, ...address}"
            tableWidth="80%"
            @handleClose="handleClose"
        ></Log>
    </paper>
</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import { mapState } from 'vuex';
import mPane from '@/components/otpPanel';
import config from './config';
import paper from '@/components/core/paper/Paper';
import { getCostOrderInfos, verifyOrder, cancelVerifyOrder, cancelPushOrderInfo, pushOrderInfo, getLog } from '@otp/api/threeplBillingOrder';
import lotsButton from '@/components/lots/lotsButton';
import Import from '@otp/components/common/Import';
import { dictWithUrl } from '@/components/lots/api.js';
import reportExport from '@/components/lots/reportExportPlugin';
import { showTableListTransform } from './beforeShowListFunc';
import EditDialog from '../components/EditDialog';
import Log from '../components/Log';

export default {
    name: 'threeplBillingOrder',
    components: { mPane, paper, lotsButton, Import, reportExport, EditDialog, Log },
    data() {
        return {
            config: config,
            loading: false,
            totalData: [],
            pageTotal: 0,
            searchTotalTitle: config.searchTotalTitle,
            visible: false,
            dialog: config.dialog,
            searchParams: {
                pageSize: 10,
                pageNo: 1
            },
            selectedRows: [],
            dictData: {},
            ImportContent: config.ImportContent,
            logVisible: false,
            logTitle: '操作日志',
            logTableData: [],
            logOrderNo: '',
            logJumpParams: {},
            address: {},
            customerOrderInfo: {}
        };
    },
    methods: {
        showEditDialog() {
            this.$refs.editDialog.show();
        },
        getDictList() {
            dictWithUrl('ANNTO_FORMWORK_OTP,TPL_EXCUTE_STATUS').then(res => {
                if (res && +res.code === 0) {
                    this.dictData = res.data;
                    const { ANNTO_FORMWORK_OTP } = res.data;
                    this.ImportContent[0].downLoadInfo.url = ANNTO_FORMWORK_OTP.ORDERCENTER_ORDEROUT;
                }
            });
        },
        changeDateFormat(arr) {
            arr = arr || [];
            arr.forEach((item, index) => {
                arr[index] = dayjs(item).format('YYYY-MM-DD HH:mm:ss');
            });
            return arr;
        },
        toFirstPage() {
            this.searchParams.pageNo = 1;
            this.getList();
        },
        timeFormat() {
            let { createTime } = this.searchParams;
            if (createTime) {
                createTime = this.changeDateFormat(createTime);
                this.searchParams.createStartTime = createTime[0];
                this.searchParams.createEndTime = createTime[1];
            }
        },
        async getList() {
            this.timeFormat();
            const params = Object.assign({}, this.searchParams);
            const msg = this.searchLimit(params);
            if (msg) {
                this.$message.warning(msg);
                return;
            }
            params.createTime = this.changeDateFormat(params.createTime);
            this.deleteNullSearchParams(params);
            Reflect.deleteProperty(params, 'createTime');
            this.loading = true;
            const res = await getCostOrderInfos(params).finally(() => {
                this.loading = false;
            });
            if (res && res.code === '0') {
                const list = _.get(res, 'data.list', []);
                this.totalData = showTableListTransform(list, this.dictData);
                this.pageTotal = res.data.totalCount;
            }
        },
        searchLimit(params) {
            if (!params.createTime && !params.customerOrderNo) {
                return '客户订单号 或 时间不可为空！';
            }
        },
        deleteNullSearchParams(searchParams) {
            for (const key in searchParams) {
                if (!searchParams[key]) {
                    delete searchParams[key];
                }
            }
        },
        rowDBclick(row) {
            // 表格内双击事件
            this.$hideTooltip();
            this.$router.push({
                query: { orderNo: row.orderNo, apartStatus: row.apartStatus },
                path: '/order-manage/threepl-billing-order-detail'
            });
        },
        checkBtn(data) {
            // 表格内按钮查看事件;
            this.visible = true;
        },
        selectChange(data) {
            // 表格内选择变化
            this.selectedRows = data;
        },
        switchChange(data) {
            // 表格内switch切换事件
        },
        searchListChange(config, data) {
            this.searchParams[config.value] = data || '';
        },
        searchChange(data) {
            // 提交搜索框
            this.searchParams = { ...this.searchParams, ...data };
            this.searchParams.pageNo = 1;
            this.getList();
        },
        pageChange(data) {
            // 分页器页数变化
            this.searchParams.pageNo = data;
            this.getList();
        },
        sizeChange(data) {
            // 分页器页数大小变化
            this.searchParams.pageSize = data;
            this.getList();
        },
        addData() {
            // 表格新增方法
            this.$refs.tablePage.$refs.table.addRow();
        },
        saveData(data) {
        },
        getTableConfigList(data) {},
        getUploadResult(flag) {
            if (flag) {
                this.getList();
            }
        },
        checkSelectRow() {
            if (!this.selectedRows.length) {
                this.$message.warning('请选择数据');
                return true;
            }
        },
        // 审核、取消审核
        verify(cancel) {
            if (this.checkSelectRow()) return;
            const successTxt = cancel ? '取消审核成功' : '审核成功';
            const data = this.selectedRows.map(item => item.orderNo);
            (cancel ? cancelVerifyOrder : verifyOrder)(data).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(successTxt);
                    this.toFirstPage();
                }
            });
        },
        // 推送
        pushOrder(cancel = 0) {
            if (this.checkSelectRow()) return;
            const successTxt = cancel ? '取消计费成功' : '推送计费成功';
            const data = this.selectedRows.map(item => {
                return {
                    id: item.id,
                    orderNo: item.orderNo
                };
            });
            (cancel ? cancelPushOrderInfo : pushOrderInfo)(data).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(successTxt);
                    this.toFirstPage();
                }
            });
        },
        // 导出
        exportFile(submit) {
            // 列表数据为空导出时处理
            const tableLength = this.totalData.length;
            if (!tableLength) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            }
            this.timeFormat();
            const exportParams = Object.assign({}, this.searchParams);
            const msg = this.searchLimit(exportParams);
            // 有数据时需要弹出，无数据时不用弹出
            if (msg) return tableLength ? this.$message.warning(msg) : '';
            submit({ ...exportParams, tenantCode: this.currentTenant.tenantCode });
        },
        editBtn(row) {
            // 表格内按钮修改事件;
            this.$refs.editDialog.show(row);
        },
        btnClick(val, index, row) {
            this.logJumpParams.customerOrderNo = row.customerOrderNo;
            this.logJumpParams.ownerCode = row.customerCode;
            this.logJumpParams.ownerName = row.customerName;
            this.logJumpParams.siteCode = row.siteCode;
            this.logJumpParams.siteName = row.siteName;
            this.logJumpParams.whCode = row.whCode;
            this.logJumpParams.whName = row.whName;
            this.logJumpParams.companyCode = row.companyCode;
            this.logJumpParams.companyName = row.companyName;
            this.logOrderNo = row.orderNo;
            getLog({ orderNo: row.orderNo }).then(res => {
                if (res && +res.code === 0) {
                    this.logTableData = res.data;
                    this.logTitle = `订单日志(客户订单号：${row.customerOrderNo})`;
                    this.logVisible = true;
                }
            });
        },
        handleClose() {
            this.logVisible = false;
        }
    },
    computed: {
        ...mapState(['user', 'currentTenant'])
    },
    created() {
        this.getDictList();
    }
};
</script>
<style lang="less">
</style>
